import { productosDB, ventasDB, clientesDB, movimientosDB } from './index'

/** Handlers activos de PouchDB sync */
let handlers = []

/** Listeners del estado del sync */
let listeners = []

/**
 * Suscribirse a cambios de estado del sync.
 * @returns función para cancelar la suscripción
 */
export function onSyncEstado(fn) {
  listeners.push(fn)
  return () => { listeners = listeners.filter(l => l !== fn) }
}

function emit(estado, detalle = null) {
  listeners.forEach(fn => fn(estado, detalle))
}

/**
 * Inicia sincronización live+retry con un servidor CouchDB.
 * Sincroniza: productos, ventas, clientes, movimientos.
 * NO sincroniza: config, usuarios, categorías (locales por sucursal).
 * @param {string} dbPrefix — prefijo CouchDB-safe, ej: "t73404420114f4079"
 */
export function iniciarSync(url, usuario, password, dbPrefix) {
  detenerSync()

  const base = url.replace(/\/$/, '')
  const prefix = dbPrefix ? `${dbPrefix}_` : 'practicaja_'
  const opts = {
    live: true,
    retry: true,
    auth: { username: usuario, password },
  }

  const dbs = [
    [productosDB,    `${base}/${prefix}productos`],
    [ventasDB,       `${base}/${prefix}ventas`],
    [clientesDB,     `${base}/${prefix}clientes`],
    [movimientosDB,  `${base}/${prefix}movimientos`],
  ]

  emit('conectando')

  // 'pausado' solo cuando TODOS los syncs están idle (no uno cualquiera)
  const pausedIds = new Set()

  handlers = dbs.map(([db, remoteUrl], i) =>
    db.sync(remoteUrl, opts)
      .on('active',  ()    => { pausedIds.delete(i); emit('activo', new Date()) })
      .on('change',  ()    => { pausedIds.delete(i); emit('activo', new Date()) })
      .on('paused',  ()    => {
        pausedIds.add(i)
        if (pausedIds.size === dbs.length) emit('pausado', new Date())
      })
      .on('error',   (err) => emit('error', err))
      .on('denied',  (err) => emit('error', err))
  )
}

/** Cancela todos los handlers de sync activos. */
export function detenerSync() {
  handlers.forEach(h => { try { h.cancel() } catch { /* ignorar */ } })
  handlers = []
}
